import React from 'react';
import { apiBase } from '../../utils/config';
import '../../assets/scss/_Result.scss';
import UserImage from '../../assets/images/UserImage.png';
import SignPlaceHolder from '../../assets/images/sign_placeholder.png';
import SealPlaceHolder from '../../assets/images/seal_placeholder.png';
import moment from 'moment';

const ResultCardPDF = React.forwardRef((props, ref) => {
    const { templateConfiguration, pdfData } = props;

    const getFullName = (fileData = {}, nameType) => {
        const nameFormats = {
            FirstSurname: `${fileData?.FirstName ?? ''} ${fileData?.SurName ?? ''}`,
            SurnameFirstName: `${fileData?.SurName ?? ''} ${fileData?.FirstName ?? ''}`,
            FirstFatherNameSurname: `${fileData?.FirstName ?? ''} ${fileData?.FName ?? ''} ${fileData?.SurName ?? ''}`,
            SurnameFirstFatherName: `${fileData?.SurName ?? ''} ${fileData?.FirstName ?? ''} ${fileData?.FName ?? ''}`,
            FirstMotherNameSurname: `${fileData?.FirstName ?? ''} ${fileData?.MName ?? ''} ${fileData?.SurName ?? ''}`,
            SurnameFirstMotherName: `${fileData?.SurName ?? ''} ${fileData?.FirstName ?? ''} ${fileData?.MName ?? ''}`,
        };
        return nameFormats[nameType] ?? `${fileData?.FirstName ?? ''} ${fileData?.SurName ?? ''}`;
    };

    const hasBody = (key) => templateConfiguration?.BodySection?.some(x => x?.key === key);
    const hasFooter = (key) => templateConfiguration?.FooterSection?.some(x => x?.key === key);

    const borderColor = `#${templateConfiguration?.BorderColor || 'FF6500'}`;
    const isTermBased = templateConfiguration?.IsShowTerm;
    const isCoScholasticShow = templateConfiguration?.IsShowCoscholastic;

    return (
        <>
            {pdfData?.map((student, idx) => {
                const activityData = student.GradeDetails?.filter(item => item.Type === 'Activity') || [];
                const elementsData = student.GradeDetails?.filter(item => item.Type === 'Elements') || [];
                const termActivityKeys = activityData.length > 0
                    ? Object.keys(activityData[0]).filter(key => !['name', 'type'].includes(key?.toLowerCase()))
                    : [];
                const termElementsKeys = elementsData.length > 0
                    ? Object.keys(elementsData[0]).filter(key => !['name', 'type'].includes(key?.toLowerCase()))
                    : [];

                return (
                    <div className="rc-page" ref={idx === 0 ? ref : undefined} id={`result-${idx}`} key={idx}>
                        <div className="rc-bordered" style={{ borderColor }}>
                            {templateConfiguration?.BackgroundImage && <header>
                                <div style={{ width: '100%' }}>
                                    <img
                                        src={`${apiBase}/Documents/${templateConfiguration?.BackgroundImage}`}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </header>}
                            {templateConfiguration?.WaterMarkImage &&
                                <div style={{ backgroundColor: 'transparent', borderRadius: '50%', position: 'absolute', top: '14%', left: '1%', opacity: 0.12 }}>
                                    <img
                                        src={`${apiBase}/Documents/${templateConfiguration.WaterMarkImage}`}
                                        onError={(e) => { e.target.onerror = null; }}
                                        alt=""
                                    />
                                </div>}
                            <div className="rc-info-section">
                                <div className="rc-title">
                                    {(hasBody('StudentPhoto') && student?.ProfilePhotoUrl) &&
                                        <div className="rc-title__photo">
                                            <img src={`${apiBase}/UserProfilePic/${student?.ProfilePhotoUrl}`} alt="Student" />
                                        </div>}
                                    <div className="rc-title__group">
                                        <div className="rc-title__report-card">Report Card</div>
                                        <div className="rc-title__class">Class : <span>
                                            {hasBody('Class') ? student.Class : ''}{hasBody('Section') && student.Section ? ` ${student.Section}` : ''}
                                        </span></div>
                                        {hasBody('AcademicYear') && (
                                            <div className="rc-title__year">Academic Year : <span>{student.AcademicYear ?? '-'}</span></div>
                                        )}
                                    </div>
                                </div>
                                <div className="rc-student-info">
                                    <div className="rc-student-info__details">
                                        <div className="rc-student-info__labels">
                                            {hasBody('StudentName') && <p>Student's Name :</p>}
                                            {hasBody('FName') && <p>Father's Name :</p>}
                                            {hasBody('DOB') && <p>Date of Birth :</p>}
                                            {hasBody('Address') && <p>Address :</p>}
                                        </div>
                                        <div className="rc-student-info__values">
                                            {hasBody('StudentName') && <p>{getFullName(student, templateConfiguration?.NameType)}</p>}
                                            {hasBody('FName') && <p>{student.FName || '-'}</p>}
                                            {hasBody('DOB') && <p>{moment(student.DOB).format('DD-MM-YYYY')}</p>}
                                            {hasBody('Address') && <p>{student.Address || '-'}</p>}
                                        </div>
                                    </div>
                                    <div className="rc-student-info__numbers">
                                        <div className="rc-student-info__num-label">
                                            {hasBody('RollNo') && <p>Roll No.</p>}
                                            {hasBody('GRNo') && <p>G. R. No.</p>}
                                        </div>
                                        <div className="rc-student-info__num-value">
                                            {hasBody('RollNo') && <p>{student.RollNo ?? '-'}</p>}
                                            {hasBody('GRNo') && <p>{student.GRNo ?? '-'}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="rc-table">
                                {!isTermBased && <div className="rc-table__title-bar">Scholastic Area</div>}
                                <table>
                                    <thead>
                                        {isTermBased &&
                                            <tr>
                                                <th className="rc-bg-yellow" rowSpan="2">Scholastic<br />Area</th>
                                                {student.TermData.map((term, tIdx) => {
                                                    const colCount = Object.keys(student.MarksData?.[0]?.[term.TermName] || {}).length;
                                                    return (
                                                        <th key={tIdx} className={tIdx % 2 === 0 ? 'rc-bg-peach' : 'rc-bg-blue'} colSpan={colCount}>
                                                            {`${term.TermName} (${term.Marks} Marks)`}
                                                        </th>
                                                    );
                                                })}
                                                <th className="rc-bg-green rc-overall-header" colSpan="2">
                                                    OVERALL
                                                    <div className="rc-t1t2">
                                                        {student.TermData.map(t => t.TermName.replace(/term\s*/i, 'T')).join(' + ')}
                                                    </div>
                                                </th>
                                            </tr>}
                                        <tr>
                                            {!isTermBased && <th className="rc-bg-yellow">Subjects</th>}
                                            {student.TermData.map((term, tIdx) =>
                                                Object.keys(student.MarksData?.[0]?.[term.TermName] || {}).map((testType, ttIdx) => (
                                                    <th key={`${tIdx}-${ttIdx}`} className={tIdx % 2 === 0 ? 'rc-bg-peach' : 'rc-bg-blue'}>
                                                        {testType}
                                                    </th>
                                                ))
                                            )}
                                            {student?.MarksData?.[0]?.ExtraColumns &&
                                                <th className="rc-bg-green">{student?.MarksData?.[0]?.ExtraColumns ? `${student?.MarksData?.[0]?.ExtraColumns?.label}` : ''}</th>}
                                            <th className="rc-bg-green">{student.MarksData?.[0]?.GrandTotalType ? `${student.MarksData[0].GrandTotalType}` : ''}</th>
                                            <th className="rc-bg-green">Grade</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {student.MarksData?.map((subject, sIdx) => (
                                            <tr key={sIdx}>
                                                <td className="rc-subject"><b>{subject.Subject}</b></td>
                                                {student.TermData.map((term, tIdx) =>
                                                    Object.keys(subject[term.TermName] || {}).map((testType, ttIdx) => (
                                                        <td key={`${tIdx}-${ttIdx}`} className="rc-mark">
                                                            {subject[term.TermName]?.[testType] == 0 ? '-' : subject[term.TermName]?.[testType] ?? '-'}
                                                        </td>
                                                    ))
                                                )}
                                                {subject?.ExtraColumns &&
                                                    <td className="rc-total"><b>{subject?.ExtraColumns?.value ?? '-'}</b></td>}
                                                <td className="rc-total"><b>{subject?.IsGrade ? '-' : subject.GrandTotal == 0 ? '-' : subject.GrandTotal ?? '-'}</b></td>
                                                <td className="rc-total"><b>{subject.Grade ?? '-'}</b></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="rc-grade-scale">
                                <div className="rc-grade-scale__label">
                                    <p><i>{student.GradeData?.GradeTemplateName ?? '-'}</i></p>
                                    <p><i>(Indicators)</i></p>
                                </div>
                                <div className="rc-grade-scale__boxes">
                                    {student.GradeData?.GradeTemplateValues?.map((grade, gIdx) => (
                                        <span key={gIdx} className="rc-grade-box" style={{ backgroundColor: `#${grade.HexCode}` }}>
                                            {grade.GradeName}({grade.PercentageFrom}%-{grade.PercentageTo}%){gIdx < student.GradeData.GradeTemplateValues.length - 1 ? ',' : ''}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            {isCoScholasticShow &&
                                <div className="rc-coscholastic">
                                    {activityData.length > 0 && (
                                        <div className="rc-coscholastic__block">
                                            <div className="rc-coscholastic__header">
                                                <p className="rc-coscholastic__title">Co-Scholastic Areas</p>
                                                <p className="rc-coscholastic__scale">( 3 Point Grading Scale A,B,C )</p>
                                            </div>
                                            <table className="rc-coscholastic__table">
                                                <thead>
                                                    <tr>
                                                        <th className="rc-co-th-activity">Activities</th>
                                                        {isTermBased
                                                            ? termActivityKeys.map((tk, i) => (
                                                                <th key={i} className="rc-co-th-grade">{tk.replace(/term\s*/i, 'T')}</th>
                                                            ))
                                                            : <th className="rc-co-th-grade" colSpan={termActivityKeys.length}>Grade</th>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {activityData.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{item.Name}</td>
                                                            {isTermBased
                                                                ? termActivityKeys.map((tk, j) => (
                                                                    <td key={j}>{item[tk] || '-'}</td>
                                                                ))
                                                                : termActivityKeys.map((tk, j) => (
                                                                    <td key={j}>{item[tk] || '-'}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {elementsData.length > 0 && (
                                        <div className="rc-coscholastic__block">
                                            <div className="rc-coscholastic__header">
                                                <p className="rc-coscholastic__title">Discipline</p>
                                                <p className="rc-coscholastic__scale">( 3 Point Grading Scale A,B,C )</p>
                                            </div>
                                            <table className="rc-coscholastic__table">
                                                <thead>
                                                    <tr>
                                                        <th className="rc-co-th-activity">Elements</th>
                                                        {isTermBased
                                                            ? termElementsKeys.map((tk, i) => (
                                                                <th key={i} className="rc-co-th-grade">{tk.replace(/term\s*/i, 'T')}</th>
                                                            ))
                                                            : <th className="rc-co-th-grade" colSpan={termActivityKeys.length}>Grade</th>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {elementsData.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{item.Name}</td>
                                                            {isTermBased
                                                                ? termElementsKeys.map((tk, j) => (
                                                                    <td key={j}>{item[tk] || '-'}</td>
                                                                ))
                                                                : termActivityKeys.map((tk, j) => (
                                                                    <td key={j}>{item[tk] || '-'}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>}
                            <div className="rc-overall">
                                <div className="rc-overall__header">Overall</div>
                                <div className="rc-overall__row">
                                    {hasFooter('Marks') && (
                                        <div className="rc-overall__item">
                                            <span className="rc-overall__label">Marks</span>
                                            <span className="rc-overall__value">{student.TotalMarks ?? '-'}</span>
                                        </div>
                                    )}
                                    {hasFooter('Percentage') && (
                                        <div className="rc-overall__item">
                                            <span className="rc-overall__label">Percentage</span>
                                            <span className="rc-overall__value rc-overall__value--highlight">{student.Percentage ?? '-'}</span>
                                        </div>
                                    )}
                                    {hasFooter('Grade') && (
                                        <div className="rc-overall__item">
                                            <span className="rc-overall__label">Grade</span>
                                            <span className="rc-overall__value">{student.Grade ?? '-'}</span>
                                        </div>
                                    )}
                                    {hasFooter('Rank') && (
                                        <div className="rc-overall__item">
                                            <span className="rc-overall__label">Rank</span>
                                            <span className="rc-overall__value">
                                                {templateConfiguration?.IsRankByType ? student.ClassRank ?? '-' : student.SectionRank ?? '-'}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="rc-overall__row">
                                    {hasFooter('Attendance') && (
                                        <div className="rc-overall__item rc-overall__item--half">
                                            <span className="rc-overall__label">Attendance</span>
                                            <span className="rc-overall__value">{student.Attendance ?? '-'}</span>
                                        </div>
                                    )}
                                    <div className="rc-overall__item rc-overall__item--half">
                                        <span className="rc-overall__label">Remarks</span>
                                        <span className="rc-overall__value rc-overall__value--red">{student.Remarks ?? '-'}</span>
                                    </div>
                                </div>
                            </div>

                            {/* --- Signature Section --- */}
                            <div className="rc-signature">
                                <div className="rc-signature__col">
                                    <img
                                        src={templateConfiguration?.SchoolLogo ? `${apiBase}/Documents/${templateConfiguration.SchoolLogo}` : SealPlaceHolder}
                                        onError={(e) => { e.target.onerror = null; e.target.src = SealPlaceHolder; }}
                                        alt="School Logo"
                                    />
                                    <p className="rc-signature__date">{moment().format('DD-MM-YYYY')}</p>
                                </div>
                                <div className="rc-signature__col rc-signature__col--center">
                                    <img
                                        src={templateConfiguration?.SealImage ? `${apiBase}/Documents/${templateConfiguration.SealImage}` : SealPlaceHolder}
                                        onError={(e) => { e.target.onerror = null; e.target.src = SealPlaceHolder; }}
                                        alt="School Seal"
                                    />
                                    <p className="rc-signature__role">Class Teacher</p>
                                </div>
                                <div className="rc-signature__col">
                                    <img
                                        src={templateConfiguration?.PrincipalSignImage ? `${apiBase}/Documents/${templateConfiguration.PrincipalSignImage}` : SignPlaceHolder}
                                        onError={(e) => { e.target.onerror = null; e.target.src = SignPlaceHolder; }}
                                        alt="Principal Signature"
                                    />
                                    <p className="rc-signature__role"><b>PRINCIPAL</b></p>
                                </div>
                            </div>

                        </div>
                        <p className="rc-footer">
                            {[
                                hasFooter('SCLAddress') && student.SchoolAddress,
                                hasFooter('SCLPhone') && student.SchoolPhone,
                                hasFooter('SCLEmail') && student.SchoolEmail,
                            ].filter(Boolean).join(', ')}
                        </p>
                    </div>
                );
            })}
        </>
    );
});

export default ResultCardPDF;

/* =====================================================================
   ORIGINAL DYNAMIC CODE (OLD .reault-main NAMESPACE - COMMENTED OUT)
   Kept for reference. Uses old CSS classes, replaced by .rc-page above.
   =====================================================================

import React from 'react';
import { apiBase } from '../../utils/config';
import '../../assets/scss/_Result.scss';
import UserImage from '../../assets/images/UserImage.png';
import SignPlaceHolder from '../../assets/images/sign_placeholder.png';
import SealPlaceHolder from '../../assets/images/seal_placeholder.png';
import moment from 'moment';

const ResultCardPDF = React.forwardRef((props, ref) => {
    const { templateConfiguration, pdfData } = props;
    const pdfBlocks = [];
    const getFullName = (fileData = {}, nameType) => {
        const nameFormats = {
            FirstSurname: `${fileData?.FirstName ?? ''} ${fileData?.SurName ?? ''}`,
            SurnameFirstName: `${fileData?.SurName ?? ''} ${fileData?.FirstName ?? ''}`,
            FirstFatherNameSurname: `${fileData?.FirstName ?? ''} ${fileData?.FName ?? ''} ${fileData?.SurName ?? ''}`,
            SurnameFirstFatherName: `${fileData?.SurName ?? ''} ${fileData?.FirstName ?? ''} ${fileData?.FName ?? ''}`,
            FirstMotherNameSurname: `${fileData?.FirstName ?? ''} ${fileData?.MName ?? ''} ${fileData?.SurName ?? ''}`,
            SurnameFirstMotherName: `${fileData?.SurName ?? ''} ${fileData?.FirstName ?? ''} ${fileData?.MName ?? ''}`,
        };
        return nameFormats[nameType] ?? `${fileData?.FirstName ?? ''} ${fileData?.SurName ?? ''}`;
    }

    const gradientStyle = (colorCode) => {
        return {
            background: colorCode
                ? `#${colorCode}`
                : '',
            borderRadius: '4px',
            padding: '10px',
        };
    };

    pdfData?.map((x, idx) => {
        const activityData = x?.GradeDetails?.filter(item => item.Type === 'Activity') || [];
        const elementsData = x?.GradeDetails?.filter(item => item.Type === 'Elements') || [];
        const termElementsKeys = elementsData.length > 0
            ? Object.keys(elementsData[0])?.filter(key => !['name', 'type'].includes(key?.toLowerCase()))
            : [];
        const termActivityKeys = activityData.length > 0
            ? Object.keys(activityData[0])?.filter(key => !['name', 'type'].includes(key?.toLowerCase()))
            : [];
        pdfBlocks.push(
            <div className='reault-main' ref={ref} key={idx} id={`result-${idx}`}>
                <div className='student-result' style={{ ...gradientStyle(templateConfiguration?.BorderColor) }}>
                    {templateConfiguration?.BackgroundImage &&
                        <header>
                            <div style={{ width: '100%' }}>
                                <img
                                    src={`${apiBase}/Documents/${templateConfiguration?.BackgroundImage}`}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        // e.target.src = UserImage;
                                    }}
                                />
                            </div>
                        </header>}
                    <div className='result-report'>
                        {templateConfiguration?.WaterMarkImage &&
                            <div style={{ backgroundColor: 'transparent', borderRadius: '50%', position: 'absolute', top: '14%', left: '1%', opacity: 0.12 }}>
                                <img src={templateConfiguration?.WaterMarkImage ? `${apiBase}/Documents/${templateConfiguration?.WaterMarkImage}` : ''}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                    }} />
                            </div>}
                        <section class="report-info">
                            <div className='report-box'>
                                <p className='report-text'>report card</p>
                            </div>
                            <div className='class-box'>
                                <p className='class-text'>class : <span>{templateConfiguration?.BodySection?.filter(x => x?.key === 'Class').length > 0 && x?.Class}{templateConfiguration?.BodySection?.filter(x => x?.key === 'Section').length > 0 && x?.Section && ' - '}{templateConfiguration?.BodySection?.filter(x => x?.key === 'Section').length > 0 && x?.Section}</span></p>
                            </div>
                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'AcademicYear').length == 1 && <div className='class-box'>
                                <p className='ay-text'>academic year : <span>{x?.AcademicYear ?? '-'}</span></p>
                            </div>}
                            <div className='student-info-row'>
                                {(templateConfiguration?.BodySection?.filter(x => x?.key === 'StudentPhoto').length > 0 && x?.ProfilePhotoUrl) && (
                                    <div className='student-photo'>
                                        <img
                                            src={`${apiBase}/UserProfilePic/${x?.ProfilePhotoUrl}`}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                // e.target.src = UserImage;
                                            }}
                                        />
                                    </div>
                                )}
                                <div className='student-details'>
                                    <div className='student-texts'>
                                        <div className='text-box-par'>
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'StudentName').length == 1 &&
                                                <p>student's name :</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'FName').length == 1 &&
                                                <p>father's name :</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'DOB').length == 1 && <p>date of birth :</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'Address').length == 1 && <p>address :</p>}
                                        </div>
                                        <div className='text-box-cha'>
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'StudentName').length == 1 && <p> {getFullName(x, templateConfiguration?.NameType)}</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'FName').length == 1 && <p>{x?.FName || '-'}</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'DOB').length == 1 && <p>{moment(x?.DOB).format("DD-MM-YYYY")}</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'Address').length == 1 && <p>{x?.Address || '-'}</p>}
                                        </div>
                                    </div>
                                    <div className='student-numbers'>
                                        <div className='text-par'>
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'RollNo').length == 1 && <p className=''>roll no</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'GRNo').length == 1 && <p className=''>g. r. no.</p>}
                                        </div>
                                        <div className='text-cha'>
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'RollNo').length == 1 && <p>{x?.RollNo ?? '-'}</p>}
                                            {templateConfiguration?.BodySection?.filter(x => x?.key === 'GRNo').length == 1 && <p>{x?.GRNo ?? '-'}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="result-table footer-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='yello'>Scholastic Area</th>
                                        {x?.TermData.map((term, index) => (
                                            <>
                                                <th key={index} className={index % 2 === 0 ? 'light-peach' : 'light-bluish'} colSpan={Object.keys(x?.MarksData?.[0]?.[term.TermName] || {}).length}>
                                                    {`${term.TermName} (${term?.Marks} Marks)`}
                                                </th>
                                            </>
                                        ))}
                                        <th colspan="2" className='p-p-0 light-yello'>Overall
                                            <p className='t1-t2 light-yello'>T1 + T2</p>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className='yello'>Subject</th>
                                        {x?.TermData.map((term, index) => (
                                            Object.keys(x?.MarksData?.[0]?.[term?.TermName] || {}).map(testType => (
                                                <th className={index % 4 === 0 ? 'light-peach' : 'light-bluish'}>{testType}</th>
                                            ))
                                        ))}
                                        {x?.MarksData?.[0]?.GrandTotalType &&
                                            <th className='light-yello'>
                                                {x?.MarksData?.[0]?.GrandTotalType || 0}
                                            </th>}
                                        <th className='light-yello'>Grade</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {x?.MarksData.map(subject => (
                                        <tr key={subject?.Subject}>
                                            <td>{subject?.Subject}</td>
                                            {x?.TermData.map(term => (
                                                Object.keys(subject?.[term.TermName] || {}).map(testType => (
                                                    <td className='purple'>{subject?.[term.TermName]?.[testType] == 0 ? '-' : subject?.[term.TermName]?.[testType] ?? '-'}</td>
                                                ))
                                            ))}
                                            {x?.MarksData?.[0]?.GrandTotalType &&
                                                <td>{subject?.GrandTotal == 0 ? '-' : subject?.GrandTotal ?? '-'}</td>
                                            }
                                            <td>{subject?.Grade ?? '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="footer-row">
                                <div className="column-one">
                                    <p className="title">{x?.GradeData?.GradeTemplateName ?? '-'}</p>
                                </div>
                                <div className="grades-container">
                                    {x?.GradeData?.GradeTemplateValues?.map((grade) => (
                                        <div
                                            key={grade._id}
                                            className="grade-box"
                                            style={{ backgroundColor: `#${grade.HexCode}` }}
                                        >
                                            <span className="grade-text">
                                                {grade?.GradeName} ({grade?.PercentageFrom} – {grade?.PercentageTo})
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>
                        <div className='co-main-box'>
                            {activityData.length > 0 && <div className='co-left'>
                                <div className='grad-points'>
                                    <p>co scholastic ares</p>
                                    <p>(3 point grading scale a,b,c)</p>
                                </div>
                                <div className="co-acti">
                                    <div className="text-par">
                                        <p className="p-text-center">activities</p>
                                        {activityData.map((item, idx) => (
                                            <p className="text" key={idx}>{item.Name}</p>
                                        ))}
                                    </div>

                                    {termActivityKeys.map((termKey, termIdx) => (
                                        <div className="text-cha" key={termIdx}>
                                            <p>{termKey.toLowerCase().replace("term", "t ")}</p>
                                            {activityData.map((item, i) => (
                                                <p className="text" key={i}>{item[termKey] || '-'}</p>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>}
                            {elementsData.length > 0 && <div className='co-left'>
                                <div className='grad-points'>
                                    <p>co scholastic ares</p>
                                    <p>(3 point grading scale a,b,c)</p>
                                </div>
                                <div className="co-acti">
                                    <div className="text-par">
                                        <p className="p-text-center">elements</p>
                                        {elementsData?.map((item, idx) => (
                                            <p className="text" key={idx}>{item?.Name}</p>
                                        ))}
                                    </div>

                                    {termElementsKeys.map((termKey, termIdx) => (
                                        <div className="text-cha" key={termIdx}>
                                            <p>{termKey?.toLowerCase().replace("term", "t ")}</p>
                                            {elementsData.map((item, i) => (
                                                <p className="text" key={i}>{item[termKey] || '-'}</p>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>}
                        </div>
                        <div className='overall-main'>
                            <p className='overall-text'>overall</p>
                            <div className='overall-cha'>
                                {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Marks').length &&
                                    <div className='overall-numbers border-left'>
                                        <div className='text-par'>
                                            <p className=''>marks</p>
                                        </div>
                                        <div className='text-cha'>
                                            <p className=''>{x?.TotalMarks ?? 0}</p>
                                        </div>
                                    </div>}
                                {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Percentage').length &&
                                    <div className='overall-numbers'>
                                        <div className='text-par'>
                                            <p className=''>percentage</p>
                                        </div>
                                        <div className='text-cha'>
                                            <p className=''>{x?.Percentage}</p>
                                        </div>
                                    </div>}
                                {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Grade').length &&
                                    <div className='overall-numbers'>
                                        <div className='text-par'>
                                            <p className=''>grade</p>
                                        </div>
                                        <div className='text-cha'>
                                            <p className=''>{x?.Grade ?? '-'}</p>
                                        </div>
                                    </div>}
                                {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Rank').length &&
                                    <div className='overall-numbers border-right'>
                                        <div className='text-par'>
                                            <p className=''>rank</p>
                                        </div>
                                        <div className='text-cha'>
                                            <p className=''>{templateConfiguration?.IsRankByType ? x?.ClassRank ?? '-' : x?.SectionRank ?? '-'}</p>
                                        </div>
                                    </div>}
                            </div>
                            <div className='overall-cha'>
                                {templateConfiguration?.FooterSection?.filter(x => x?.key === 'Attendance').length &&
                                    <div className='overall-numbers border-left p-m-0'>
                                        <div className='text-par'>
                                            <p className=''>attendance</p>
                                        </div>
                                        <div className='text-cha'>
                                            <p className=''>{x?.Attendance ?? '-'}</p>
                                        </div>
                                    </div>}
                                <div className='overall-numbers border-right p-m-0'>
                                    <div className='text-par'>
                                        <p className=''>remarks</p>
                                    </div>
                                    <div className='text-cha'>
                                        <p className=''>{x?.Remarks ?? '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='sign-main'>
                            <div className='sign-cha'>
                                <img
                                    src={templateConfiguration?.SchoolLogo ? `${apiBase}/Documents/${templateConfiguration?.SchoolLogo}` : SealPlaceHolder}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = SealPlaceHolder;
                                    }}
                                />
                                <p>{moment().format("DD-MM-YYYY")}</p>
                            </div>
                            <div className='sign-cha center'>
                                <img
                                    src={templateConfiguration?.SealImage ? `${apiBase}/Documents/${templateConfiguration?.SealImage}` : SignPlaceHolder}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = SignPlaceHolder;
                                    }}
                                />
                                <p>class teacher</p>
                            </div>
                            <div className='sign-cha'>
                                <img
                                    src={templateConfiguration?.PrincipalSignImage ? `${apiBase}/Documents/${templateConfiguration?.PrincipalSignImage}` : SignPlaceHolder}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = SignPlaceHolder;
                                    }}
                                />
                                <p>principal</p>
                            </div>
                        </div>
                    </div>
                </div>
                <p className='footer-text'>
                    {templateConfiguration?.FooterSection?.filter(x => x?.key === 'SCLAddress').length && x?.SchoolAddress}, {templateConfiguration?.FooterSection?.filter(x => x?.key === 'SCLPhone').length && x?.SchoolPhone},
                    {templateConfiguration?.FooterSection?.filter(x => x?.key === 'SCLEmail').length && x?.SchoolEmail}
                </p>
            </div>
        )
    });
    return pdfBlocks;
});

export default ResultCardPDF;

=====================================================================
   END ORIGINAL DYNAMIC CODE
   ===================================================================== */
